// export default BgvTimerComponent;
import { useState, useEffect } from "react";
import "./bgv_timer.style.css";
import Map from "./Map";

const BgvTimerComponent = () => {
  const TOTAL_BGV_6_YEARS = 2225400;
  const [getRequestCount, setGetRequestCount] = useState(() => {
    const storedCount = localStorage.getItem("getRequestCount");
    return storedCount && !isNaN(parseInt(storedCount))
      ? parseInt(storedCount)
      : 0;
  });
  const [totalBGV, setTotalBGV] = useState(
    TOTAL_BGV_6_YEARS + (parseInt(localStorage.getItem("getRequestCount")) || 0)
  );
  const isNightTime = () => {
    const now = new Date();
    const hours = now.getHours();
    return hours >= 22 || hours < 6;
    // return hours === 13;
  };

  // Update totalBGV when getRequestCount changes
  useEffect(() => {
    setTotalBGV(TOTAL_BGV_6_YEARS + getRequestCount);
    localStorage.setItem("getRequestCount", getRequestCount.toString());
  }, [getRequestCount]);

  const formatNumber = (num) => {
    if (isNaN(num) || num === null || num === undefined) return "0";
    return Math.round(num)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="mx-2 mt-6 lg:mb-14 counter-container flex items-center justify-center rounded-[24px]">
      <div className="w-full max-w-full text-white relative overflow-hidden">
        <div className="flex bgv-insight-container flex-col lg:flex-row md:gap-6 md:flex-col justify-between">
          <div className="md:w-full flex justify-start items-center">
            <Map
              setGetRequestCount={setGetRequestCount}
              isNightTime={isNightTime}
            />
          </div>
          <div className="md:w-full flex justify-center md:pb-12 items-center">
            <div className="flex flex-col md:pr-4">
              <div className="md:mx-auto lg:mx-0">
                <p className="bg-white text-center relative top-2 left-14 lg:left-0 md:left-0 w-[130px] text-xs font-medium text-[#1179C2] px-4 py-2 rounded-[3px] transition duration-200">
                  Total
                </p>
                <div className="bg-white lg:w-[350px] md:w-[350px] w-[280px] mx-auto lg:mx-0 md:mx-0 border bg-opacity-20 py-2 rounded-lg text-center">
                  <span className="text-sm">
                    {isNightTime() ? "Paused" : "Live"}
                  </span>
                  <p className="text-4xl font-semibold font-georama count-up">
                    {formatNumber(totalBGV)}
                  </p>
                  <hr className="border-t-4 relative top-3 rounded-md border-white" />
                </div>
              </div>
              <div className="mt-8 rounded-lg flex flex-col items-center justify-center col-span-2">
                <div className="lg:text-start text-center px-4 lg:px-0">
                  <h2 className="lg:text-5xl md:text-5xl text-4xl font-normal">
                    Real-Time BGV Insights
                  </h2>
                  <p className="lg:text-[18px] text-[14px] md:w-2/3 lg:w-2/3 lg:text-start md:text-center md:mx-auto lg:mx-0 font-normal mt-4 lg:pb-0 md:pb-0 pb-8">
                    We're Scaling Faster Than Ever — Powering Trust And Safety
                    With Every Background Verification Done.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BgvTimerComponent;
